module.exports = __webpack_public_path__ + "assets/img/nb-intro1.737a46ed.jpg";